import { TrackingManager } from '@benzinga/tracking-manager';
import { getSessionSingleton } from '@benzinga/session';

const slugifyNavSegment = (value: string): string => {
  const slug = value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '');
  return slug || 'item';
};

export const handleMenuItemsClickEvent = (buttonLocation: string, linkType: string, buttonLabel?: string): void => {
  const session = getSessionSingleton();
  const placement = slugifyNavSegment(linkType);
  const itemSlug = slugifyNavSegment(buttonLabel ?? '');
  session.getManager(TrackingManager).trackLinkEvent('click', {
    button_id: `nav_${placement}_${itemSlug}`,
    button_label: buttonLabel,
    button_location: buttonLocation,
    button_type: 'navigation',
    link_type: linkType,
  });
};

export type HubNavUserState = 'anon' | 'free' | 'edge' | 'pro';

export type HubEventType = 'hub_opened' | 'hub_link_clicked';

export interface HubEventParams {
  type: HubEventType;
  hub: string;
  label?: string;
  destination?: string;
  userState: HubNavUserState;
  element?: 'title';
  location?: string;
}

export const trackHubEvent = ({
  type,
  hub,
  label,
  destination,
  userState,
  element,
  location = 'hub_nav',
}: HubEventParams): void => {
  const session = getSessionSingleton();
  const hubSlug = slugifyNavSegment(hub);
  const action: 'view' | 'click' = type === 'hub_opened' ? 'view' : 'click';
  const buttonId =
    type === 'hub_opened'
      ? `hubnav_${hubSlug}_opened_${userState}`
      : `hubnav_${hubSlug}_${element ?? slugifyNavSegment(label ?? '')}_${userState}`;
  session.getManager(TrackingManager).trackLinkEvent(action, {
    button_id: buttonId,
    button_label: label,
    button_location: location,
    button_type: 'navigation',
    link_type: hub,
    link_url: destination,
  });
};
